<template>
  <v-container class="pa-0" v-bind:class="{semiWhite: page.centerText !== '' || page.bottomText !== '' || page.leftImage !== '' || gameType === 'aop'}" fill-height>
      <v-row v-if="this.gameStep.step && this.gameStep.step.type === 'aop'" no-gutters justify="center">
        <v-col cols="12" xs="4" sm="4" md="3" lg="2" xl="1">
          <v-card outlined tile v-for="element in aop.products" class="list-group-item" :key="element.order">
            <span>{{ element.name }}</span>
          </v-card>
        </v-col>
        <v-col cols="12" xs="4" sm="4" md="3" lg="2" xl="1">
          <draggable tag="ul" v-model="aop.places" :move="handleMove" @start="handleStart" :options="{isTarget: true}" :disabled="gameStep.tryValidateAop" group="places">
            <v-card outlined tile v-for="(element, index) in aop.places" class="list-group-item" :key="index"
              :class="[Object.keys(element).length === 0 ? 'transparent empty' : 'card-hover', gameStep.tryValidateAop ? element.valid ? 'green': 'red' : '']">
              <span>{{ element.name }}</span>
            </v-card>
          </draggable>            
        </v-col>
        <v-col cols="12" xs="4" sm="4" md="3" lg="2" xl="1">
          <draggable tag="ul" v-model="aop.originPlaces" :move="handleMove" @start="handleStart" :options="{isTarget: false}" :disabled="gameStep.tryValidateAop" group="places" ref="originPlaces">
            <v-card outlined tile v-for="(element, index) in aop.originPlaces" class="list-group-item" :key="index" :class="[Object.keys(element).length === 0 ? 'transparent' : 'card-hover']">
              <span>{{ element.name }}</span>
            </v-card>
          </draggable>            
        </v-col>
      </v-row>
      <v-row v-else no-gutters justify="center">
        <v-col v-if="hasLeftImage" cols="12" sm="4" >
            <div class="oneThirdLeft pa-4">
                <img :src="leftImage" />
                <div class="pageSeparator" />
            </div>
        </v-col>
        <v-col v-if="page.centerText != '' || page.bottomText != ''" cols="12" sm="8" transition="fade-transition">
            <div v-if="page.centerText != ''" class="centerContent pa-4" v-html="page.centerText" />
            <div v-if="page.bottomText != ''" class="bottomContent pa-4" v-html="page.bottomText" />
        </v-col>
      </v-row>
      <slot name="timer"></slot>
      <v-row no-gutters justify="center">
        <slot name="action-bar"></slot>
      </v-row> 
  </v-container>
</template>

<script>
  import draggable from "vuedraggable";

  export default {
    name: 'GameContent',
    components: {draggable},
    props: {
      page: {
        type: Object,
        default: () => {
          return {}
        },
      },
      gameStep: {
        type: Object,
        default: () => {
          return {}
        },
      }
    },
    data: () => ({
      aop: {
        products: [],
        places: [],
        originPlaces: [],
        tmpPlaces: []
      }
    }),
    watch: {
      'gameStep.tryValidateAop': function (newValue, oldValue) {
        if (newValue && !oldValue) {
          this.gameStep.step.places.sort((a,b) => a.id - b.id)
          this.aop.places = SAPIO.Game.instance.gameStep.answers.map((el, index) => {
            if (!el.id || (el.id && this.aop.products[index].id.toString() !== el.id.toString())) 
              return Object.assign(this.gameStep.step.places[index], {valid: false})
            return Object.assign(el, {valid: el.id && this.aop.products[index].id.toString() === el.id.toString()})
          })
          this.aop.originPlaces = []
        }
      }
    },
    computed: {
        leftImage: function () {
            return this.image || this.page.leftImage
        },
        hasLeftImage: function () {
            return this.leftImage != undefined && this.leftImage != null && this.leftImage.length > 0
        },
        gameType: function () {
          return this.gameStep.step ? this.gameStep.step.type : {}
        }
    },
    mounted() {
      if (this.gameType === "aop") {
        if (this.gameStep.tryValidateAop) {
          this.gameStep.step.places.sort((a,b) => a.id - b.id)
          this.aop.places = SAPIO.Game.instance.gameStep.answers.map((el, index) => {
            if (!el.id || (el.id && this.aop.products[index].id.toString() !== el.id.toString())) 
              return Object.assign(this.gameStep.step.places[index], {valid: false})
            return Object.assign(el, {valid: el.id && this.aop.products[index].id.toString() === el.id.toString()})
          })
          this.aop.originPlaces = []
        } else {
          this.aop.products = this.gameStep.step.products;
          this.aop.originPlaces = this.gameStep.step.places
          this.aop.places = this.aop.originPlaces.map(x => Object.assign({}));
          this.aop.products.sort((a, b) => a.id - b.id);
          this.aop.originPlaces.sort(() => 0.5 - Math.random());
          this.aop.originPlaces.sort(() => 0.5 - Math.random());
          this.aop.originPlaces.sort(() => 0.5 - Math.random());
        }
      }
    },
    methods: {
      handleStart() {
        this.aop.tmpPlaces = [this.aop.places, this.aop.originPlaces]
      },
      handleMove(e) {
        var toTarget = e.to[Object.keys(e.to).filter(k => k.startsWith('Sortable'))[0]].options.isTarget
        var fromTarget = e.from[Object.keys(e.from).filter(k => k.startsWith('Sortable'))[0]].options.isTarget
        
        if ((fromTarget || toTarget) && Object.keys(e.draggedContext.element).length === 0) return false
        if (e.draggedContext.futureIndex >= Math.min(this.aop.places.length, this.aop.originPlaces.length)) return false

        this.aop.places = [...this.aop.tmpPlaces[0]]
        this.aop.originPlaces = [...this.aop.tmpPlaces[1]]

        var tmp = !toTarget ? this.aop.originPlaces[e.draggedContext.futureIndex] : this.aop.places[e.draggedContext.futureIndex] 
        if (!toTarget) this.aop.originPlaces.splice(e.draggedContext.futureIndex, 1, e.draggedContext.element)
        else this.aop.places.splice(e.draggedContext.futureIndex, 1, e.draggedContext.element)
        if (fromTarget) this.aop.places.splice(e.draggedContext.index, 1, tmp)
        else this.aop.originPlaces.splice(e.draggedContext.index, 1, tmp)
        
        return false
      },
    },
  }
</script>

<style scoped>
  .pageSeparator {
    position: absolute;
    width: 1.5%;
    height: 80%;
    top: 10%;
    right: -0.75%;
    background-color: #858585;
    border-radius: 30px 30px 30px 30px;
    max-width: 10px;
  }

  .centerText {
    position: absolute;
    width: 100%;
    padding: 50px;
    font-size: 2em;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .centerContent {
    top: 50%;
    position: relative;
    transform: translateY(-50%);
  }

  .semiWhite {
    background-color: rgba(255, 255, 255, 0.8);
  }

  .titleBar {
    background-color: rgba(255, 255, 255, 0.9);
    height: 10.7%;
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
  }
  .pageTitle {
    right: 4.3%;
    font-size: 160%;
    position: absolute;
    top: 2vh;
    font-weight: bold;
  }

  .oneThirdLeft {
    position: relative;
    height: 100%;
    line-height: 1;
  }

  .oneThirdLeft img {
    max-width: 100%;
    height: auto;
    top: 50%;
    left: 50%;
    position: relative;
    transform: translate(-50%, -50%);
  }

  .actionBar {
    position: absolute;
    width: 100%;
    height: 62px;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .list-group-item {
    height: 40px;
    text-align: center;
    background: white;
    margin-bottom: 5px;
    position: relative;
  }

  .list-group-item span {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
    width: 100%;
  }

  .card-shadow-on {
    box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    transition: all 0.3s cubic-bezier(.25,.8,.25,1);
  }

  .card-shadow-off {
    box-shadow: 0 0px 0px rgba(0,0,0,0.12), 0 0px 0px rgba(0,0,0,0.24);
    transition: all 0.3s cubic-bezier(.25,.8,.25,1);
  }

  .card-hover {
    cursor: grabbing;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    transition: all 0.3s cubic-bezier(.25,.8,.25,1);
  }

  .card-hover:hover {
    box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    transition: all 0.3s cubic-bezier(.25,.8,.25,1);
  }

  .empty {
    border: 1px dashed black !important;
  }

  .empty::before {
    content: "?";
    position: absolute;
    top: 55%;
    transform: translateY(-50%);
  }
 </style>
